import { purify } from "../../../_src/components/purify";

export function searchInternalCourses() {
    var btnLoadMore = document.querySelector("[data-action=load-more]")

    function search() {
        btnLoadMore.classList.add("loading")

        fetch(`/senar/cursos-e-treinamentos/ajax/cursos-interna/?slug=${btnLoadMore.getAttribute("data-slug")}&page=${btnLoadMore.getAttribute("data-page")}`)
        .then((response) => {
            return response.text();
        }).then((response) => {
            document.querySelector("#result-internal-courses").innerHTML = purify(response);

            if (document.querySelector("#result-not-found")) {
                btnLoadMore.disabled = true
                document.querySelector("#result-not-found").remove()
            } else {
                btnLoadMore.disabled = false
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            btnLoadMore.classList.remove("loading")
            if (parseInt(btnLoadMore.dataset.page) >= parseInt(btnLoadMore.dataset.total)) {
                btnLoadMore.classList.add("hidden")
            }
            btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 3
        });
    }

    btnLoadMore.addEventListener("click", function() { search() }, false);

    return search()
}

if (document.querySelector("#result-internal-courses")) {
    searchInternalCourses();
}
